import React, { useState } from 'react';
import styles from './CustomSnackbar.module.css';
import { Snackbar, SnackbarContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


const CustomSnackbar = ({ open, message, onClose }) => {
    const styles = {
        snackbar: {
            width: '100%',
            maxWidth: '600px',
        },
        content: {
            backgroundColor: '#FDD3BB', // Light cream/beige color
            color: '#973A03', // Dark brown for text
            display: 'flex',
            padding: '6pxpx 16px',
            borderLeft: '6px solid #973A03', // Dark brown left border
            borderRadius: '0px',
            boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.1)',
        },
        warningIconContainer: {
            display: 'flex',
            alignItems: 'center',
            marginRight: '12px',
        },
        warningIcon: {
            backgroundColor: '#973A03',
            color: 'white',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '16px'
        },
        message: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
        },
        icon: {
            marginRight: '12px',
            color: '#973A03', // Dark brown for icon
            display: 'flex',
            alignItems: 'center',
        },
        closeButton: {
            marginLeft: 'auto',
            color: '#973A03', // Dark brown for close icon
        }
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={10000}
            onClose={onClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={styles.snackbar}
        >
            <SnackbarContent
                sx={styles.content}
                message={
                    <div style={styles.message}>
                        <div style={styles.warningIconContainer}>
                            <div style={styles.warningIcon}>!</div>
                        </div>
                        {message}
                    </div>
                }
                action={
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={onClose}
                        sx={styles.closeButton}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            />
        </Snackbar>
    );
};

export default CustomSnackbar